import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function EthereumIcon({
  width = 50,
  height = 50,
  fill = 'white',
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill={fill}
      {...props}
    >
      <path
        opacity={0.2}
        d="M29.92 15c0 8.24-6.68 14.921-14.92 14.921-8.242 0-14.922-6.68-14.922-14.92C.078 6.76 6.758.078 15 .078 23.24.08 29.92 6.76 29.92 15z"
        fill="#B8C5D3"
      />
      <path
        d="M15.037 3.13v.012c.012.059.012.13.012.2v8.525c-.012.047-.048.06-.083.083-.248.118-.485.224-.733.33-.343.155-.698.32-1.04.474l-1.242.567c-.343.154-.686.308-1.017.461-.402.19-.816.367-1.217.556-.343.154-.686.32-1.04.473-.285.13-.568.248-.84.378-.024.012-.048.024-.071.024-.012 0-.012 0-.024-.012l.32-.532c.614-1.017 1.217-2.022 1.832-3.038.65-1.088 1.312-2.176 1.963-3.263.602-1.005 1.217-2.01 1.82-3.015.438-.733.887-1.466 1.324-2.2.012-.023.024-.035.024-.058h.012c-.012.011 0 .023 0 .035z"
        fill="#8A92B2"
      />
      <path
        d="M22.294 15.201l.012.012-1.738 1.028-5.462 3.228c-.023.012-.047.024-.059.035-.035 0-.035-.035-.035-.047v-7.413c0-.035 0-.082.011-.118.012-.047.048-.035.083-.024.154.071.32.142.473.213.461.213.922.426 1.383.627.402.177.793.366 1.195.544.401.177.803.366 1.206.544.342.153.697.319 1.04.473.343.153.697.319 1.04.472.272.119.544.249.816.367 0 .035.012.047.035.059z"
        fill="#454A75"
      />
      <path
        d="M15.037 26.846c0 .012-.012.024-.012.036h-.012c0-.024-.024-.036-.035-.06-.733-1.028-1.466-2.068-2.2-3.097-.744-1.052-1.5-2.116-2.246-3.168-.72-1.017-1.454-2.046-2.175-3.062-.19-.272-.378-.532-.568-.804-.011-.024-.023-.036-.047-.071.036 0 .06.023.071.035 1.029.603 2.045 1.206 3.074 1.81 1.182.697 2.353 1.394 3.535 2.092l.603.354c.024.024.024.048.024.071v5.699c0 .059 0 .118-.012.165z"
        fill="#8A92B2"
      />
      <path
        d="M7.73 15.225v-.012c.379-.166.745-.343 1.124-.508.484-.225.97-.438 1.454-.663.366-.165.745-.342 1.111-.508.544-.248 1.076-.485 1.62-.733.366-.165.733-.331 1.111-.508.26-.119.532-.237.792-.355.024-.012.06-.024.071-.047.012 0 .012.011 0 .023v7.508c0 .035-.012.07.012.094-.024.036-.047 0-.06-.011-.105-.06-.212-.119-.318-.19-2.282-1.348-4.576-2.707-6.857-4.055-.012-.012-.036-.024-.06-.035zM22.27 16.62h.013c0 .023-.024.047-.036.07-2.175 3.063-4.35 6.137-6.526 9.199-.225.319-.461.638-.686.957-.012-.012-.012-.023-.012-.035V20.9c.497-.296.982-.58 1.478-.875 1.915-1.135 3.83-2.258 5.734-3.393.012.011.024 0 .036-.012z"
        fill="#62688F"
      />
      <path
        d="M15.024 11.914V3.236c0-.035-.012-.059.012-.094 2.4 3.984 4.8 7.957 7.188 11.94.023.036.059.084.07.13-.165-.058-.319-.141-.472-.212-.19-.083-.39-.177-.58-.26-.118-.06-.248-.107-.366-.166-.201-.094-.402-.177-.603-.271-.118-.048-.236-.107-.355-.166l-.78-.355c-.13-.059-.26-.118-.402-.177l-.567-.248c-.119-.048-.237-.107-.355-.166l-.78-.355c-.13-.059-.26-.118-.402-.177l-.568-.248c-.13-.06-.248-.118-.378-.178-.225-.106-.45-.212-.686-.307.036-.012.024-.012.024-.012z"
        fill="#62688F"
      />
    </svg>
  );
}

const MemoEthereum = React.memo(EthereumIcon);
export default MemoEthereum;
